import $ from "jquery";
import _ from "underscore";
import UserGroup from "../../locktable/UserGroup";
import messageResource from "../../messageResource";
import {escapeHtmlSymbols} from "../../atUtils";
import {atImgPath} from "../../atBrowserUtils";
import TableRow from "../../table/TableRow";
import DatesRow from "../../locktable/rows/DatesRow";
import RunnerRow from "../../locktable/rows/RunnerRow";
import {DateFormat} from "../../date_format";
import {
    addBottomBorderRow, addHeaderCells, addLeaveTypeToUserRow, addOtherTasksRow,
    addOvertimeRow, addSeparateRow, addTaskRow, addUserRow, buildMonthRow
} from "../../lock_table";
import SelectionScrollController from "../../locktable/SelectionScrollController";
import SelectionVeil from "../../locktable/SelectionVeil";
import LockEventsHandler from "../../locktable/LockEventsHandler";
import LockTable from "../../locktable/LockTable";
import LockTableTooltipController from "../../locktable/LockTableTooltipController";
import RunnerController from "../../locktable/RunnerController";
import CommentsController from "../../locktable/CommentsController";
import ExpandedUsersStorage from "../../locktable/ExpandedUsersStorage";
import LockTTStore from "./LockTTStore";
import TaskRow from "../../locktable/rows/TaskRow";

export default class LockTTTableController {
    init()
    {
        return this;
    }

    createLockTable(containerElement, onLockedTillDateChange)
    {
        let dateFormat = LockTTStore.getDateFormat();
        let dateParser = {
            parse(dateStr) { return parseDate(dateStr, TimeUtils.UNIFORM_DATE_FORMAT); }
        };

        let userGroupsList = [];
        let table = this._createTableObj(dateFormat, userGroupsList, onLockedTillDateChange);
        table.buildDOM(containerElement);
        for (let i = 0; i < userGroupsList.length; i++)
        {
            userGroupsList[i].fitHeightOnBuildDomComplete();
        }

        this.userGroupsList = userGroupsList;

        let scrollController = new SelectionScrollController();
        scrollController.linkTo(table);

        let selectionVeil = new SelectionVeil(LockTTStore.getSelectionVeilImages(), $(".lockTableWrapper")[0]);
        table.addLockEventsListener(new LockEventsHandler(dateFormat, dateParser, LockTTStore.getTimestamp(),
            selectionVeil, table.clearSelection, table, new DateFormat("MMM dd")));
        if (!LockTTStore.isLockTableImagesLoaded())
        {
            LockTTStore.setLockTableImagesLoaded(true);
            setTimeout(preloadLockTableImages, 500);
        }
    }

    _createTableObj(dateFormat, userGroupsList, onLockedTillDateChange)
    {
        let userMap = this._convertBeanArrayToMap(LockTTStore.getUsers().concat(LockTTStore.getDeletedUsers()));
        let table = new LockTable(LockTTStore.getLoggedInUserToday(), LockTTStore.getWeekStartDay() - 1);
        let selectionController = table.getSelectionController();
        let hoverController = table.getHoverController();
        let tooltipController = new LockTableTooltipController(userMap, "lockDayTitle", Date.dayNamesShort);
        let runnerController = new RunnerController(LockTTStore.getLockedTillDate(),
            selectionController,
            hoverController,
            LockTTStore.getAllLockedTillDateBeyondDateRange());
        runnerController.addPositionChangeListener(onLockedTillDateChange);
        table.init(runnerController, tooltipController, new CommentsController(dateFormat));
        selectionController.setLockTable(table);
        let expandedUsersStorage = new ExpandedUsersStorage();


        //header rows
        let note = null;
        if (LockTTStore.getDisabledUsersSelected())
        {
            note = {
                imgPath: atImgPath("note_mark.gif"),
                text: messageResource.getMessage("lock_tt.table.header.disabled_users_note")
            };
        }
        let order = LockTTStore.getSortingOrder();
        let topMessageKey = "lock_tt.table.header.users_tasks";
        if (order == UserListSortConstant.ORDER_BY_USER_GROUP)
        {
            topMessageKey = "lock_tt.table.header.groups_users";
        }
        else if (order == UserListSortConstant.ORDER_BY_TIME_ZONE_GROUP)
        {
            topMessageKey = "lock_tt.table.header.time_zone_groups_users";
        }

        let topMessage = messageResource.getEscapedMessage(topMessageKey);
        let sortByLink = "";
        let isUserGroupEnabled = LockTTStore.getEnabledFeatures().UGR;
        let isTimeZoneGroupEnabled = LockTTStore.getEnabledFeatures().TZG;
        let onlyOneFeatureEnabled = isUserGroupEnabled ^ isTimeZoneGroupEnabled;
        let showDetails = !LockTTStore.isHideDetailsOnLockTT();

        if (isUserGroupEnabled || isTimeZoneGroupEnabled)
        {
            sortByLink = showDetails ? ' | ' : '';
            let createSortLink = function(sortBy, text)
            {
                return '<a data-sortBy=' + sortBy +
                       ' href="javascript:void(0);" onclick="changeSortingOrder(this)" class="changeSortingOrder noprint">' +
                       text + '</a>\u00a0\u00a0';
            };
            if (order != UserListSortConstant.ORDER_BY_USERNAME)
            {
                sortByLink += createSortLink(UserListSortConstant.ORDER_BY_USERNAME,
                    messageResource.getMessage(onlyOneFeatureEnabled ? "lock_tt.table.header.sort_by_user_name" : "lock_tt.table.header.by_user"));
            }
            if (order != UserListSortConstant.ORDER_BY_USER_GROUP && isUserGroupEnabled)
            {
                sortByLink += createSortLink(UserListSortConstant.ORDER_BY_USER_GROUP,
                    messageResource.getMessage(onlyOneFeatureEnabled ? "lock_tt.table.header.sort_by_user_group" : "lock_tt.table.header.by_group"));
            }
            if (order != UserListSortConstant.ORDER_BY_TIME_ZONE_GROUP  && isTimeZoneGroupEnabled)
            {
                sortByLink += createSortLink(UserListSortConstant.ORDER_BY_TIME_ZONE_GROUP,
                    messageResource.getMessage(onlyOneFeatureEnabled ? "lock_tt.table.header.sort_by_time_zone" : "lock_tt.table.header.by_time_zone"));
            }
        }

        buildMonthRow(table, LockTTStore.getMonths(), true, note, topMessage, sortByLink, showDetails);

        let runner = new RunnerRow();
        let datesRow = new DatesRow(Date.dayNamesShort);
        datesRow.addCellObjWithoutAppend(TableRow.prototype.createCellObj(null));
        runner.addCellObjWithoutAppend(TableRow.prototype.createCellObj(null));

        _.each(LockTTStore.getHeaderData(), function(headerDatum)
        {
            let isRunnerOver = !_.isNull(LockTTStore.getLockedTillDate()) && headerDatum.date <= LockTTStore.getLockedTillDate();
            addHeaderCells(datesRow,
                runner,
                headerDatum.date,
                headerDatum.isHoliday,
                isRunnerOver,
                headerDatum.hasLockedInvisibleUser,
                headerDatum.hasUnlockedInvisibleUser);
        });

        table.addRow(runner);
        table.addDatesRow(datesRow);

        //User rows
        let isFirstGroup = true;
        let previousGroup;
        let from = LockTTStore.getDateRangeConfig().fromDate;
        let to = LockTTStore.getDateRangeConfig().toDate;
        let columnCount = to.offsetInDaysFrom(from) + 1;
        _.each(LockTTStore.getUserDataGroups(), function(userGroupObj)
        {
            let label = escapeHtmlSymbols(userGroupObj.label);
            if (userGroupObj.continued)
            {
                label += " " + messageResource.getMessage("lock_tt.table.user_group.continued_suffix");
            }
            if (_.isNull(userGroupObj.usersData) || userGroupObj.usersData.length == 0)
            {
                addSeparateRow(table, columnCount, isFirstGroup, label);
                previousGroup = null;
            }
            else
            {
                if (previousGroup)
                {
                    previousGroup.removeBottomBorder();
                }
                let userGroup = new UserGroup(label);
                previousGroup = userGroup;
                userGroupsList.push(userGroup);
                let showDetails = !LockTTStore.isHideDetailsOnLockTT();

                _.each(userGroupObj.usersData, function(userDatum)
                {
                    _.each(userDatum.userRowValues, function(userRowValue)
                    {
                        userRowValue.lockDate = !userRowValue.lockDate ? null :
                                                _.isString(userRowValue.lockDate) ? Date.parseJSONDate(userRowValue.lockDate) : userRowValue.lockDate;
                    });
                    _.each(userDatum.userRowApproveValues, function(userRowApproveValue)
                    {
                        userRowApproveValue.approvedDate = !userRowApproveValue.approvedDate ? null :
                                                           _.isString(userRowApproveValue.approvedDate) ?
                                                           Date.parseJSONDate(userRowApproveValue.approvedDate) : userRowApproveValue.approvedDate;
                    });

                    let userRow = addUserRow(userGroup, table, userMap[userDatum.userId], userDatum.userRowValues, userDatum.userRowApproveValues,
                        userDatum.workingDays, expandedUsersStorage, Date.parseJSONDate(userDatum.userToday));
                    let leaveTimeText = messageResource.getMessage("lock_tt.table.leave_time");

                    if (showDetails) {
                        _.each(userDatum.leaveTypes, function(leaveTypeInfo) {
                            let leaveType = LeaveTypeStore.getLeaveType(leaveTypeInfo.leaveTypeId);
                            addLeaveTypeToUserRow(userRow,
                                {
                                    name: escapeHtmlSymbols(leaveType.name),
                                    iconPath: getLeaveTypeIconPath(leaveType.iconId),
                                    printIconPath: getLeaveTypePrintIconPath(leaveType.iconId)
                                },
                                leaveTypeInfo.leaveRowValues,
                                leaveTimeText);
                        });
                    }

                    if (showDetails){
                        _.each(userDatum.tasks, function(userTask)
                        {
                            userTask.task.projectName = escapeHtmlSymbols(userTask.task.projectName);
                            userTask.task.customerName = escapeHtmlSymbols(userTask.task.customerName);
                            addTaskRow(userRow, userTask.task, userTask.taskRowValues);
                        });
                    }

                    if (showDetails) {
                        if (!_.isNull(userDatum.otherTasksTime)) {
                            let message = messageResource.getEscapedMessage(userDatum.tasks.length == 0 ?
                                                                            "lock_tt.table.tasks_not_assigned" :
                                                                            "lock_tt.table.other_tasks_not_assigned");
                            addOtherTasksRow(userRow, message, userDatum.otherTasksTime);
                        }
                    }

                    if (showDetails) {
                        if (userDatum.showOvertime) {
                            if (!_.isNull(userDatum.reportedOvertime)) {
                                addOvertimeRow(userRow,
                                    messageResource.getMessage("lock_tt.table.overtime_row.reported", [messageResource.getMessage("overtime.overtime")]),
                                    userDatum.reportedOvertime);
                            }
                            addOvertimeRow(userRow,
                                messageResource.getMessage("lock_tt.table.overtime_row.auto_calculated",
                                    [messageResource.getMessage("overtime.overtime_lower_case")]),
                                userDatum.autocalculatedOvertime);
                        }
                    }
                });
                isFirstGroup = false;
            }
        });
        addBottomBorderRow(table, columnCount);
        return table;
    }

    _convertBeanArrayToMap(beans)
    {
        let map = [];
        for (let i = 0; i < beans.length; i++)
        {
            let bean = beans[i];
            map[bean.id] = bean;
        }
        return map;
    }

    _updateTask(task){
        this.userGroupsList.forEach(userGroup => {
            userGroup.userRows.forEach(userRow => {
                userRow.childRows.forEach(childRow => {
                    const cell = childRow.cells[0];
                    if (childRow instanceof TaskRow && cell.value.id === task.id) {
                        cell.value.name = task.name;
                        cell.value.completed = task.completed;
                        cell.value.workflowStatusId = task.workflowStatusId;
                        cell.value.commentsNumber = task.commentsNumber
                        cell.updateCell();
                    }
                })
            })
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/user/locktt/LockTTTableController.js